module.exports = __webpack_public_path__ + "assets/img/02.k8s-dashboard-port.5ab7a770.png";